import { AxiosResponse } from "axios";
import axios, { configHeader, getHeaders } from "./axios";

export interface PostMenuBody {
  name: string;
  description: string;
  category_id: number;
  image?: string;
  imageFileId?: string;
  availableDays?: number[];
  availableFromMin?: number | null;
  availableToMin?: number | null;
  dailyStock?: number | null;
  sauces?: string[] | null;
}

export type AllMenuResponse = MenuResponseByID[];

export interface MenuResponseByID {
  id: number;
  name: string;
  createdAt: string;
  isActive: string;
  isAvailable: string;
  description: string;
  image?: string | null;
  imageFileId?: string | null;
  availableDays?: number[] | null;
  availableFromMin?: number | null;
  availableToMin?: number | null;
  dailyStock?: number | null;
  sauces?: string[] | null;
  category: Category;
}

export interface MenuStock {
  menuId: number;
  dailyStock: number;
  orderedToday: number;
  remaining: number;
}

export const getMenuStock = async (): Promise<MenuStock[]> => {
  const headers = getHeaders();
  const response: AxiosResponse<MenuStock[]> = await axios.get("/menu/stock", headers);
  return response.data;
};

export interface Category {
  id: number;
  name: string;
  isAvailable: string;
  categoryFor: string;
}

export const postMenu = async (
  body: PostMenuBody
): Promise<MenuResponseByID> => {
  const headers = configHeader();
  const menuSucces = await axios.post<MenuResponseByID>(`/menu`, body, headers);
  return menuSucces.data;
};

export const getAllMenu = async (): Promise<AllMenuResponse> => {
  const headers = getHeaders();
  const response: AxiosResponse<AllMenuResponse> = await axios.get(
    "/menu",
    headers
  );
  return response.data;
};

export interface PatchMenuBody {
  name?: string;
  description?: string;
  category_id?: number;
  isActive?: string;
  isAvailable?: string;
  image?: string;
  imageFileId?: string;
  availableDays?: number[] | null;
  availableFromMin?: number | null;
  availableToMin?: number | null;
  dailyStock?: number | null;
  sauces?: string[] | null;
}

export interface MessageResponse {
  message: string;
}

export const getMenuByID = async (id: number): Promise<MenuResponseByID> => {
  const headers = getHeaders();
  const response = await axios.get(`/menu/${id}`, headers);
  return response.data;
};

export const patchMenuByID = async (
  id: number,
  body: PatchMenuBody
): Promise<MenuResponseByID> => {
  const headers = getHeaders();
  const response = await axios.patch<MenuResponseByID>(
    `/menu/${id}`,
    body,
    headers
  );
  return response.data;
};

export const deleteMenuByID = async (id: number): Promise<MessageResponse> => {
  const headers = getHeaders();
  const response = await axios.delete(`/menu/${id}`, headers);
  return response.data;
};
